import { render, staticRenderFns } from "./MainPayService.vue?vue&type=template&id=426406fc&scoped=true"
import script from "./MainPayService.vue?vue&type=script&lang=ts"
export * from "./MainPayService.vue?vue&type=script&lang=ts"
import style0 from "./MainPayService.vue?vue&type=style&index=0&id=426406fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426406fc",
  null
  
)

export default component.exports